import { row, column, column33, column40, column50 } from 'helpers/styles/grid'
import { COLORS } from 'helpers/globals'

const label = {
  lineHeight: '3.5rem',
  ...column,
  padding: '0!important',
  marginRight: '0!important',
  color: 'black'
}

export const inputWrapper = {
  ...column,
  position: 'relative',
  padding: '0!important'
}

export const extraWideLabel = {
  ...label,
  ...column50
}

export const suffix = {
  position: 'absolute',
  textAlign: 'center',
  top: 0,
  right: '.9rem',
  lineHeight: '30px',
  height: 30
}

export default {
  container: row,
  extraWideLabel,
  wideLabel: {
    ...label,
    ...column40
  },
  normalLabel: {
    ...label,
    ...column33
  },
  narrowLabel: {
    ...label,
    flex: '0 0 22 %',
    maxWidth: '22% !important'
  },
  inputWrapper,
  suffix,
  shortWidthSuffix: {
    ...suffix,
    right: '4.5rem'
  },
  shortWidthInput: {
    width: '65%!important'
  },
  shortWidthInputGlow: {
    width: '65%!important',
    borderColor: `${COLORS.primary} !important`,
    boxShadow: '0 0 1px rgba(66, 139, 202, 1) !important'
  },
  inputGlow: {
    borderColor: `${COLORS.primary} !important`,
    boxShadow: '0 0 1px rgba(66, 139, 202, 1) !important'
  },
  bottomRowButton: {
    fontSize: '1.8rem',
    marginLeft: '1rem',
    color: '#428bca',
    cursor: 'pointer'
  },
  infoTooltip: {
    marginLeft: '1rem',
    color: COLORS.primary
  }
}



// WEBPACK FOOTER //
// ./src/components/CalculatorInput/style.js